import React from 'react';
import { connect } from 'react-redux';
import { usePage } from 'ha/modules/Page/contexts/PageContext';
import {
  LIST_YOUR_PLACE,
  APOLLO_SUPPLY_LANDING,
  BLOG_ADVERTISER,
  LISTING_DETAIL_PAGE,
} from 'ha/constants/pageNames';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import { getIsShowingAuthModal } from 'ha/modules/NavBar/selectors';

import { GlobalState } from 'ha/types/store';
import { AuthType } from 'ha/modules/AuthLogic/types';
import { useLocation } from 'ha/helpers/router';
import AuthModal from '../components/AuthModal';
import { changeModalType } from '../actions';

interface Props {
  showingModal: boolean;
  hideModal: () => void;
  modalType: string;
  returnURL?: string;
  changeModalType: (type: string) => void;
}

const AuthModalContainer: React.FC<Props> = ({
  showingModal = false,
  hideModal,
  modalType,
  returnURL = '',
  changeModalType,
}) => {
  const { name: pageName, category: pageCategory = '' } = usePage();
  const location = useLocation();
  const switchType = React.useCallback(
    e => {
      e.preventDefault();
      const modalTypeNext =
        modalType === AuthType.register ? AuthType.login : AuthType.register;

      changeModalType(modalTypeNext);
    },
    [modalType],
  );

  const isAdvertiserRoute =
    [APOLLO_SUPPLY_LANDING, BLOG_ADVERTISER].includes(pageCategory) ||
    pageName === LIST_YOUR_PLACE;

  const shouldNotRedirect = [LISTING_DETAIL_PAGE].includes(pageCategory);
  const modalProps = {
    nextUrl: shouldNotRedirect
      ? location.pathname + location.search
      : returnURL,
    hideModal,
    switchType,
    modalType,
    showingModal,
    isAdvertiserRoute,
  };

  return <AuthModal {...modalProps} />;
};

export default connect(
  (state: GlobalState, ownProps: { returnURL?: string }) => ({
    modalType: state.authModal.modalType,
    returnURL: state.authModal.returnUrl || ownProps.returnURL,
    showingModal: getIsShowingAuthModal(state),
  }),
  {
    changeModalType,
    hideModal: NavBarActions.hideModal,
  },
)(AuthModalContainer);
